import { c as _c } from "react/compiler-runtime";
import { Skeleton } from "../ui/skeleton";
import { EventCardSkeleton } from "./event-card-skeleton";
export const EventsLoader = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [...Array(5)].map(_temp);
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center justify-center gap-2 sm:justify-start"><Skeleton className="h-4 w-28" /><Skeleton className="h-8 w-18" /></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div><div className="space-y-4">{t0}<div className="mt-4 flex w-full flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">{t1}<div className="flex justify-center gap-1.5 sm:justify-end"><Skeleton className="h-8 w-8 rounded-md" /><Skeleton className="h-8 w-8 rounded-md" /><Skeleton className="h-8 w-8 rounded-md" /><Skeleton className="h-8 w-8 rounded-md" /><Skeleton className="h-8 w-8 rounded-md" /></div></div></div><span className="sr-only">Loading...</span></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  return t2;
};
function _temp(_, i) {
  return <EventCardSkeleton key={i} />;
}